import { render, staticRenderFns } from "./LaporanGadaiBaru.vue?vue&type=template&id=34f8289e&scoped=true&"
import script from "./LaporanGadaiBaru.vue?vue&type=script&lang=js&"
export * from "./LaporanGadaiBaru.vue?vue&type=script&lang=js&"
import style0 from "./LaporanGadaiBaru.vue?vue&type=style&index=0&id=34f8289e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f8289e",
  null
  
)

export default component.exports